const CommonAPI = {};

export default CommonAPI;
